/* ==========================================================
   UGC Stories – 3-s loop + Play / Pause toggle
   ========================================================== */
(() => {
  const WRAP = document.getElementById('ugc-story-carousel');
  if (!WRAP) return;

  const slides = [...WRAP.children];
  const vids   = slides.map(s => s.querySelector('video'));
  const PREVIEW_S = 3;

  /* helper: wait for first frame */
  const ready = v => new Promise(res =>
    v.readyState >= 2
      ? res()
      : v.addEventListener('loadeddata', res, { once:true })
  );

  /* ---------- looping preview ----------------------------- */
  const addLoop = v => {
    const loop = () => {
      if (v.dataset.preview === 'on' &&
          v.currentTime >= PREVIEW_S - 0.05) {
        v.currentTime = 0;
      }
    };
    v.addEventListener('timeupdate', loop);
  };

  const startPreview = async v => {
    v.dataset.preview = 'on';
    v.muted = true;
    try {
      await ready(v);
      v.currentTime = 0;
      v.play().catch(()=>{});
      if (!v.dataset.hasLoop) {
        addLoop(v);
        v.dataset.hasLoop = '1';
      }
    } catch (err) { console.warn('Preview failed', err); }
  };

  /* kick off the teaser for every card */
  vids.forEach(startPreview);

  /* ---------- handle tap ▶ / ⏸ ---------------------------- */
  WRAP.addEventListener('click', e => {
    const btn = e.target.closest('.ugc-play');
    if (!btn) return;

    const slide = btn.parentElement;
    const vid   = slide.querySelector('video');

    /* [NEW] 2nd tap → pause & return to teaser */
    if (slide.classList.contains('playing')) {
      vid.pause();
      slide.classList.remove('playing');   // icon ▶ visible otra vez
      startPreview(vid);                  // reinicia loop teaser
      return;                             // ¡listo!
    }

    /* stop all OTHER videos & restart their previews */
    vids.forEach(v => {
      if (v === vid) return;              // ← deja intacto el clickeado
      v.pause();
      v.currentTime = 0;
      v.dataset.preview = '';
      v.muted = true;
      startPreview(v);
      v.parentElement.classList.remove('playing');
    });

    /* play the selected one with audio */
    ready(vid).then(() => {
      vid.dataset.preview = '';           // disable looping
      vid.muted = false;
      slide.classList.add('playing');     // hide ▶ via CSS
      vid.play().catch(()=>{});

      /* when finished, return to preview + show ▶ icon */
      vid.addEventListener('ended', () => {
        slide.classList.remove('playing');
        startPreview(vid);
      }, { once:true });
    });
  });
})();
